// Phase II · Wave C.5a · Admin Workbench · Blog + Editorial Roles API client.
// Thin wrapper around /api/v9/blog/* and /api/v9/blog/editorial-roles/*
// endpoints · reuses the shared `apiFetch` helper so cookie auth,
// correlation IDs and error unwrapping behave identically to the rest
// of the app.
import { apiFetch } from "@/lib/api";

const qs = (params = {}) => {
    const entries = Object.entries(params).filter(
        ([, v]) => v !== undefined && v !== null && v !== "",
    );
    if (entries.length === 0) return "";
    return "?" + entries.map(
        ([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`,
    ).join("&");
};

export const blogAdminApi = {
    // ------- Posts -------
    listPosts:        (p = {}) => apiFetch(`/v9/blog/posts${qs(p)}`),
    getPost:          (id)     => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}`),
    createPost:       (body)   => apiFetch("/v9/blog/posts", {
                                     method: "POST", body: JSON.stringify(body),
                                 }),
    updatePost:       (id, body) => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}`, {
                                     method: "PUT", body: JSON.stringify(body),
                                 }),
    deletePost:       (id)     => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}`, {
                                     method: "DELETE",
                                 }),
    submitForReview:  (id)     => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}/submit-for-review`, {
                                     method: "POST",
                                 }),
    moderate:         (id, body) => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}/moderate`, {
                                     method: "POST", body: JSON.stringify(body),
                                 }),
    schedulePost:     (id, body) => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}/schedule`, {
                                     method: "POST", body: JSON.stringify(body),
                                 }),
    publish:          (id)     => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}/publish`, {
                                     method: "POST",
                                 }),
    unpublish:        (id)     => apiFetch(`/v9/blog/posts/${encodeURIComponent(id)}/unpublish`, {
                                     method: "POST",
                                 }),
    moderationQueue:  (p = {}) => apiFetch(`/v9/blog/moderation/queue${qs(p)}`),

    // ------- Editorial roles -------
    myEditorialRole:  ()       => apiFetch("/v9/blog/editorial-roles/me"),
    listRoles:        (p = {}) => apiFetch(`/v9/blog/editorial-roles${qs(p)}`),
    grantRole:        (body)   => apiFetch("/v9/blog/editorial-roles", {
                                     method: "POST", body: JSON.stringify(body),
                                 }),
    revokeRole:       (role_id) => apiFetch(`/v9/blog/editorial-roles/${encodeURIComponent(role_id)}`, {
                                     method: "DELETE",
                                 }),
    reinstateRole:    (role_id) => apiFetch(`/v9/blog/editorial-roles/${encodeURIComponent(role_id)}/reinstate`, {
                                     method: "POST",
                                 }),

    // ------- Topic clusters (used by Composer cluster picker) -------
    listClusters:     (p = {}) => apiFetch(`/v9/seo/clusters${qs(p)}`),
};

export default blogAdminApi;
